import React, { FC, useEffect, useRef, useState } from 'react';
import {
  createStyles,
  Grid,
  InputBase,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import { IBusiness, thousandSeparator } from '../utils/utils';
import { parseDecimal } from '../../../common/logics';

interface IBusinessStatusItem {
  mutationVariableName?: keyof IBusiness;
  label: string;
  value: string | number | undefined | null;
  editable?: boolean;
  setBusinessState?: React.Dispatch<React.SetStateAction<IBusiness>>;
  isNumber?: boolean;
}

const BusinessStatusItem: FC<IBusinessStatusItem> = (props) => {
  const {
    label,
    value,
    editable,
    mutationVariableName,
    setBusinessState,
    isNumber,
  } = props;
  const classes = useStyles();
  const [isEditing, setIsEditing] = useState(false);
  const [_value, _setValue] = useState<string | undefined | null>(
    value?.toString(),
  );
  const inputRef = useRef<any>(null);

  const handleFocus = () => {
    setIsEditing(true);
  };

  const setFocused = () => {
    setIsEditing(true);
    if (inputRef && inputRef.current) {
      inputRef?.current?.focus();
    }
  };

  const handleBlur = () => {
    setIsEditing(false);
    if (editable && mutationVariableName && setBusinessState) {
      setBusinessState((prev) => {
        return {
          ...prev,
          [mutationVariableName]: isNumber
            ? parseDecimal(_value?.toString())
            : _value,
        };
      });
    }
  };

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const inputText = event.target.value;
    _setValue(inputText);
  };

  useEffect(() => {
    if (value) _setValue(value?.toString());
  }, [value]);

  return (
    <>
      <Grid item xs={12} sm={5} className={classes.left}>
        <Typography className={classes.label}>{label} :</Typography>
      </Grid>
      <Grid item xs={11} sm={6} className={classes.left}>
        <InputBase
          value={
            isNumber && !isEditing && _value
              ? `${thousandSeparator(_value.toString())} €`
              : _value
          }
          type={isNumber && isEditing ? 'number' : 'text'}
          inputRef={inputRef}
          inputProps={{ 'aria-label': 'naked' }}
          className={classes.input}
          disabled={!editable}
          classes={{ disabled: classes.disabled }}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={1} sm={1} className={classes.right}>
        {editable &&
          (isEditing ? (
            <SaveIcon className={classes.icon} onClick={handleBlur} />
          ) : (
            <EditIcon className={classes.icon} onClick={setFocused} />
          ))}
      </Grid>
    </>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    left: {
      display: 'flex',
      justifyContent: 'left',
      alignItems: 'center',
    },
    label: {
      fontWeight: 'bold',
    },
    right: {
      display: 'flex',
      justifyContent: 'right',
      alignItems: 'center',
    },
    icon: {
      height: 15,
      color: '#FF4340',
      cursor: 'pointer',
    },
    input: {
      flex: 1,
    },
    disabled: {
      color: 'black',
    },
  }),
);

export default BusinessStatusItem;
